export default "__VITE_ASSET__UDdn6_Iu__"